import { defineComponent as _defineComponent } from 'vue'
import { ProblemShipmentModel } from '@/openapi';
import { ref, computed, watch } from 'vue';
import { useDataStore } from '@/store/data-store';

import { PropType, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProblemsPopup',
  props: {
    shipment: {
        type: Object as PropType<ProblemShipmentModel>,
        required: true,
    },
    shipments: {
        type: Array as PropType<ProblemShipmentModel[]>,
        default: () => [],
    },
},
  emits: ['close', 'save'],
  setup(__props, { emit }) {

const props = __props;




const dataStore = useDataStore();

const isOpen = ref(true);
const selectedIndex = ref(0);

const currentShipment = computed<ProblemShipmentModel>(() => {
    if (
        props.shipments.length > 0 &&
        props.shipments.length <= selectedIndex.value
    ) {
        selectedIndex.value = props.shipments.length - 1;
    }
    return props.shipments.length > selectedIndex.value
        ? (props.shipments[selectedIndex.value] as ProblemShipmentModel)
        : (props.shipment as ProblemShipmentModel);
});

const addDropFile = (e: DragEvent) => {
    if (e.dataTransfer && e.dataTransfer.files) {
        currentShipment.value.documents?.push(
            ...Array.from(e.dataTransfer.files)
        );
    }
};

const close = () => {
    isOpen.value = false;
    emit('close');
};

const save = () => {
    emit('save', currentShipment.value);
};

const previousShipment = () => {
    if (selectedIndex.value > 0) {
        selectedIndex.value--;
    }
};

const nextShipment = () => {
    if (selectedIndex.value < props.shipments.length - 1) {
        selectedIndex.value++;
    }
};

onMounted(() => {
    dataStore.fetchCountriesOfOrigin();
    dataStore.fetchCurrencies();
});

return { __sfc: true,props, emit, dataStore, isOpen, selectedIndex, currentShipment, addDropFile, close, save, previousShipment, nextShipment }
}

})